import React, { Component } from 'react';
import jquery from 'jquery';


class Chord extends Component{
  constructor(props){
    super(props);
    this.state={
      neck:'',
      muted:{
        'e_lo':'o',
        'a':'o',
        'd':'o',
        'g':'o',
        'b':'o',
        'e_hi':'o'
      },
      fret:0
    }
  }
  componentWillMount(){
    this.constructChord();
    let chord = {};
    for(let i=0; i<24; i++){
      chord[i]=false;
    }
    this.setState({
      chord
    });
  }
  componentDidMount(){
    const muted = jquery('.muted_strings .col-xs-2');
    muted.mouseenter((e)=>{
      const id = e.target.id;
      jquery('#'+id).html('x');
    });
    muted.mouseleave((e)=>{
      const id = e.target.id;
      if(this.state.muted[id]=='o'){
        jquery('#'+id).html('o');
      }
    });
    muted.click((e)=>{
      const id = e.target.id;
      console.log(id);
      let strings = this.state.muted;
      strings[id]=(strings[id]==='x') ? 'o' : 'x';
      this.setState({
        muted:strings
      });
      jquery('#'+id).html('x');
      console.log(this.state.muted);
    });
  }
  mutedEnter(){
    console.log('enter');
  }
  mutedLeave(){
    console.log('leave');
  }
  finger_point(){
    return "<div class='finger_point'></div>";
  }
  opaque_finger_point(){
    return "<div class='opaque_finger_point'></div>";
  }
  constructChord(){
    let strings=[];
    for(let i=0; i<24; i++){
      const id=i.toString();
      strings.push(
        (
          <div id={id} onMouseEnter={this.handleMouseEnter.bind(this)} onMouseLeave={this.handleMouseLeave.bind(this)} onClick={this.handleClick.bind(this)} className='string_section col-xs-2'>
            <div className='touchable_string'>
            </div>
          </div>
        )
      );
    }
    this.setState({
      neck:strings
    });
  }
  handleMouseEnter(e){
    e.preventDefault();
    let chord = this.state.chord;
    const $target = e.target;
    const id = $target.closest('.string_section').id;
    const string_section = '#'+id;
    console.log(string_section);
    const dot = this.opaque_finger_point();
    console.log(dot);
    if(this.state.chord[id]==false){
      jquery(string_section).append(dot);
    }
  }
  handleMouseLeave(e){
    e.preventDefault();
    let chord = this.state.chord;
    const $target = e.target;
    const id = $target.closest('.string_section').id;
    const string_section = '#'+id;
    console.log(string_section);
    const point = jquery(string_section).find('.opaque_finger_point');
      point.remove();
  }
  handleClick(e){
    e.preventDefault();
    let chord = this.state.chord;
    const $target = e.target;
    const id = $target.closest('.string_section').id;
    const point = '#'+id;
    console.log(point);
    const dot = this.finger_point();
    console.log(dot);
    if(this.state.chord[id]==false){
      jquery(point).append(dot);
      chord[id]=true;
      this.setState({
        chord
      });
    }else{
      const $node = $target.closest('.finger_point');
      console.log($node);
      $node.remove();
      chord[id]=false;
      this.setState({
        chord
      });
    }
    console.log('new chord: ',chord);
  }

  saveChord(e){
    e.preventDefault();

    var chord= {
      chord:this.state.chord,
      muted:this.state.muted,
      base:this.state.fret,
      name:this.refs.name.value,
    };
    if(this.refs.name.value==''){
      this.props.missingName();
      return;
    }
    console.log(chord);
    this.props.saveChord(chord);
    this.refs.name.value='';
    this.setState({
      neck:'',
      muted:{
        'e_lo':'o',
        'a':'o',
        'd':'o',
        'g':'o',
        'b':'o',
        'e_hi':'o'
      },
      fret:0,
      name:'',
      chord:{}
    });
    jquery('.finger_point').remove();
    this.componentWillMount();
  }
  selectFret(e){
    e.preventDefault();
    this.setState({
      fret:e.target.value
    });
  }
  render(){
    return(
      <div>
      <span className='clearfix chord_container'>
        <div className="fret_number">

          {/* <div className="fret_num">0</div> */}
        </div>
        <div className="chord_right">
          <select onChange={this.selectFret.bind(this)} value={this.state.fret} className="fret_select">
            <option>0</option>
            <option>1</option>
            <option>2</option>
            <option>3</option>
            <option>4</option>
            <option>5</option>
            <option>6</option>
            <option>7</option>
            <option>8</option>
            <option>9</option>
            <option>10</option>
            <option>11</option>
            <option>12</option>
            <option>13</option>
            <option>14</option>
            <option>15</option>
            <option>16</option>
            <option>17</option>
            <option>18</option>
            <option>19</option>
            <option>20</option>
          </select>
        </div>
        <div ref='chord' className="chord row">
          <div className='neck row'>
            <span className='col-xs-2'>E</span>
            <span className='col-xs-2'>A</span>
            <span className='col-xs-2'>D</span>
            <span className='col-xs-2'>G</span>
            <span className='col-xs-2'>B</span>
            <span className='col-xs-2'>E</span>
          </div>
          <div className='muted_strings row'>
            <span id='e_lo' className='col-xs-2'>{this.state.muted['e_lo']}</span>
            <span id='a' className='col-xs-2'>{this.state.muted['a']}</span>
            <span id='d' className='col-xs-2'>{this.state.muted['d']}</span>
            <span id='g' className='col-xs-2'>{this.state.muted['g']}</span>
            <span id='b' className='col-xs-2'>{this.state.muted['b']}</span>
            <span id='e_hi' className='col-xs-2'>{this.state.muted['e_hi']}</span>
          </div>
          { this.state.neck }
        </div>
        <div className="chord_base">
          <form className="form form-control">
            <input className="form-control" type="text" ref="name" placeholder="Chord Name" ></input>
            <span onClick = { this.saveChord.bind(this)} className="btn btn-primary">Save</span>
          </form>
        </div>
        <div>
        </div>
      </span>
    </div>
    );
  }
}

export default Chord;



// WEBPACK FOOTER //
// ./src/components/Chord.js